import PropTypes from 'prop-types';
import React from 'react';

function RadioGroup({
    ariaLabel,
    children,
    name
}) {
    return (
        <div id={name} aria-label={ariaLabel} role="radiogroup">
            {children.map(
                /* istanbul ignore next */
                (child, i) => {
                    return React.isValidElement(child) ?
                        React.cloneElement(child, {name, key: `radio-${name}-${i}`}) :
                        child;
                }
            )}
        </div>
    );
}

RadioGroup.propTypes = {
    /** name property that gets passed on to the inputs. Should be similar to a variable name (i.e. creditCardChoices) */
    name: PropTypes.string.isRequired,
    /** Radio group's label to be read by screen readers */
    ariaLabel: PropTypes.string.isRequired
};

RadioGroup.displayName = 'RadioGroup';

export default RadioGroup;
